class ShopifyForm extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector(".shopify-form--app-block");
    this.showFormButton = this.querySelector("button[data-show-form]");
    this.hideFormButton = this.querySelector("button[data-hide-form]");
  }

  connectedCallback() {
    this.showFormButton.addEventListener("click", () => this.showForm());
    this.hideFormButton.addEventListener("click", () => this.hideForm());
  }

  showForm() {
    if (this.form) {
      this.form.style.display = "block";
    }
    this.showFormButton.style.display = "none";
  }

  hideForm() {
    this.form.style.display = "none";
    this.showFormButton.style.display = "flex";
    // scroll to top of the component
    const yOffset = -200;
    const y = this.getBoundingClientRect().top + window.pageYOffset + yOffset;

    window.scrollTo({
      top: y,
      behavior: "smooth",
    });
  }
}

customElements.define("shopify-form", ShopifyForm);
